import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createQcsThunks, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import type { SalesTaxesState, SalesTaxType } from './SalesTaxesTypes';
import { SALES_TAXES_REDUCER_KEY } from './SalesTaxesTypes';
import invoiceItemsApi from './salesTaxesApi';

// Define the initial state using that type
const initialState: SalesTaxesState = {
  entities: {},
  ids: [],

  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/sales-taxes/salesTaxesSlice.ts');

const entityAdapter = createResourceEntityAdapter<SalesTaxType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: SALES_TAXES_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(salesTaxesActions.fetch());
      },
      api: invoiceItemsApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const salesTaxesActions = slice.actions;
export const salesTaxesSelectors = slice.selectors;
export { slice as salesTaxesSlice };

export default slice.reducer;
